var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge",class:{
    danger: _vm.text === _vm.dangerText,
  },style:(_vm.getBadgeStyle('#' + _vm.getColor(_vm.text))),on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }